<template>
  <a href="#" class="shedule_card_out_a">
    <div class="schedule_card_outer">
      <div class="schedule_card_date">2020-11-15</div>
      <div class="schedule_card_title">上海市中小学烂酒冠军赛小组赛</div>
      <div class="schedule_card_team_left">
        <div>{{tempItem.teamList[0].name.charAt(0)}}</div>
        <div>{{tempItem.teamList[0].name}}</div>
      </div>
      <div class="schedule_card_team_vs">
        <div>
          <img v-if="tempItem.status == 0" src="../assets/shl_home_schedule_card_vs.png" style="width: 56px;height: auto;">
          <div v-else class="schedule_card_teams_scores_vs">
            {{formatNumber(tempItem.teamList[0].score) + ' : ' + formatNumber(tempItem.teamList[1].score)}}
          </div>
        </div>
        <div>
          {{tempItem.status == 0 ? '未开始' : (tempItem.status == 1 ? '进行中' : '已结束')}}
        </div>
      </div>
      <div class="schedule_card_team_right">
        <div>{{tempItem.teamList[1].name.charAt(0)}}</div>
        <div>{{tempItem.teamList[1].name}}</div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "HomeScheduleCard",
  props: [
    'item'
  ],
  data () {
    return {
      tempItem: {
        title: '上海市中小学生篮球冠军赛小组赛',
        status: 1, // 0 未开始，1 进行中， 2，已结束
        teamList: [
          {
            name: '杨浦',
            score: '2'
          },
          {
            name: '虹口',
            score: '8'
          }
        ]
      }
    }
  },
  computed: {

  },
  methods: {
    formatNumber(number) {
      if (number >= 10) {
        return number;
      }
      if (number < 0) {
        return number;
      }
      return '0' + number;
    },
  },
  mounted() {
    // console.log('---3')
    // console.log(this.tempItem.title.charAt(0))
    // let tempNumber = 3;
    // tempNumber.toString()
    // console.log(Stringformat("%03d", tempNumber))
  }
}
</script>

<style scoped>
  .schedule_card_outer {
    width: 300px;
    height: 150px;
    background-image: url("../assets/shl_home_schedule_card_bg.png");
    background-repeat: no-repeat;
    background-size:  100% 100%;
    background-position: 1px 0px;
    position: relative;
    overflow: hidden;
    mask-clip: border-box;
    -ms-interpolation-mode: bicubic;
  }

  .shedule_card_out_a {
    text-decoration: none;
    padding: 0;
    margin-top: 30px;
    margin-left: 0;
  }



  .schedule_card_date {
    text-align: center;
    padding-top: 10px;
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
  }
  .schedule_card_title {
    text-align: center;
    margin-right: 8px;
    margin-left: 8px;
    color: white;
    font-weight: bold;
    font-size: 1rem;
    letter-spacing: 1.5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .schedule_card_team_left, .schedule_card_team_right, .schedule_card_team_vs {
    position: absolute;

  }

  .schedule_card_team_left {
    left: 43px;
    top: 53px;
  }

  .schedule_card_team_right {
    right: 43px;
    top: 53px;
  }

  .schedule_card_team_left > div:first-child, .schedule_card_team_right > div:first-child {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    border: solid 1px transparent;
    font-size: 2.8rem;
  }

  .schedule_card_team_left > div:first-child {
    background-color: rgb(221,119,73);
    color: white;
  }

  .schedule_card_team_right > div:first-child {
    background-color: rgb(222, 164, 77);
    color: rgb(197, 8, 50);
  }

  .schedule_card_team_left > div:last-child, .schedule_card_team_right > div:last-child {
    color: black;
    font-size: 0.8rem;
    font-weight: bold;
    margin-top: 20px;
    text-align: center;
  }

  .schedule_card_team_vs {
    left: 100px;
    top: 53px;
    width: 100px;

  }
  .schedule_card_team_vs > div:first-child {
    height: 50px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .schedule_card_team_vs > div:last-child {
    color: white;
    font-size: 0.8rem;
    text-align: center;
    font-weight: bold;
  }

  .schedule_card_teams_scores_vs {
    color: white;
    font-weight: bold;
    font-size: 2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomeScheduleCard.vue